// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2q24K","options":"AnswerScale_options__2r-bG","selected":"AnswerScale_selected__1lXZa"};